import React, {useState, useEffect} from 'react';
import { Button, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import { useAuth } from '../../Context/AuthContext';
import Alerta from '../../../components/Alerta';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { db } from '../../../firebase/firebaseConfig';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import { getUnixTime } from 'date-fns';
//import editarPrograma from '../../../firebase/Programa/editarPrograma';

const FormularioProgram = ({ programaSeleccionado }) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [urlarticulo, setUrlarticulo] = useState('');
	const [fecha, setFecha] = useState(new Date());
    const [categoria, setCategoria] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [imagen, setImagen] = useState(null); 
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    console.log('Estoy en FormularioProgram ' + programaSeleccionado);

    useEffect(() => {
        const obtenerPrograma = async () => {
          if (!programaSeleccionado) return; // Asegúrate de que haya una implementación seleccionado
          try {
            const programasDoc = await getDoc(doc(db, 'implementacioncalocho', programaSeleccionado));
            if (programasDoc.exists()) {
                setModoEdicion(true);
                const programaData = programasDoc.data();
                setTitulo(programaData.titulo || '');
                setEmpresa(programaData.empresa || '');
                setDescripcion(programaData.descripcion || '');
                setUrlarticulo(programaData.urlarticulo || '');
                setFecha(programaData.fecha ? new Date(programaData.fecha) : new Date());
                setCategoria(programaData.categoria || '');
                setImagen(programaData.imagen || null);
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerPrograma();
    }, [programaSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie programaSeleccionado
      
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'empresa'){
            setEmpresa(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        } else if(e.target.name === 'dirweb'){
            setUrlarticulo(e.target.value);
        } else if(e.target.name === 'categoria'){
            setCategoria(e.target.value);
        } else if (e.target.name === 'fecha'){
            setFecha(new Date(e.target.value));
        } else if (e.target.name === 'imagen') {
            const file = e.target.files[0];
            setImagen(file);
        }
    }
    
    const handleUpload = async (imagen) => {
        if (imagen) {
    
            try {
                const storageRef = getStorage(); // Obtener la instancia de almacenamiento
                const fileRef = ref(storageRef, `implementacioncalocho/${imagen.name}`); // Obtener una referencia al archivo

                // Subir la imagen
                const snapshot = await uploadBytesResumable(fileRef, imagen);
                console.log('Imagen subida correctamente:', snapshot);
    
                // Obtener la URL de descarga
                const downloadURL = await getDownloadURL(snapshot.ref);
                console.log('URL de la imagen:', downloadURL);

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen subida correctamente' });
                
                // Devuelve la URL de la imagen
                return downloadURL;

            } catch (error) {
                console.error('Error al subir la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al subir la imagen' });
                return null;
            }
        } else {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return null;
        }
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!imagen) {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return;
        }
    
        try {
            const imageUrl = await handleUpload(imagen);

            if(modoEdicion && programaSeleccionado.id){
                // Crear el objeto de datos actualizado
                //const datosActualizados = {
                //    titulo: titulo,
                //    empresa: empresa,
                //    descripcion: descripcion,
                //    urlarticulo: urlarticulo,
                //    fecha: getUnixTime(fecha),
                //    categoria: categoria,
                //    imagen: imageUrl
                //};
    
                // Llamar a la función editarPrograma con los datos actualizados
                //await editarPrograma(programaSeleccionado.id, datosActualizados);

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar una implementación
                setTitulo('');
                setEmpresa('');
                setDescripcion('');
                setUrlarticulo('');
                setFecha(new Date());
                setCategoria('');
                setImagen(null);
                programaSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Implementacion actualizado correctamente' });
            
            } else {
                

                if(imageUrl){
                    // Agregar una implementación a Firestore con la URL de la imagen
                    await addDoc(collection(db, 'implementacioncalocho'), {
                        titulo: titulo,
                        empresa: empresa,
                        descripcion: descripcion,
                        urlarticulo: urlarticulo,
                        fecha: getUnixTime(fecha),
                        categoria: categoria,
                        imagen: imageUrl, // URL de la imagen
                        uidUsuario: usuario.uid
                    });
    
                    // Limpiar el formulario después de agregar una implementación
                    setTitulo('');
                    setEmpresa('');
                    setDescripcion('');
                    setUrlarticulo('');
                    setFecha(new Date());
                    setCategoria('');
                    setImagen(null);
    
                    // Mostrar mensaje de éxito
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'exito', mensaje: 'Implementación agregada correctamente' });
                } else {
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'error', mensaje: 'Error al agregar una implementación' });
                }
            }

            // Limpiar el formulario después de agregar una implementación
            setTitulo('');
            setEmpresa('');
            setDescripcion('');
            setUrlarticulo('');
            setFecha('');
            setCategoria('');
            setImagen(null);

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar una implementación ' });
        }
    }

    return(
        <Paper onSubmit={handleSubmit} component="form" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '85%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestras implementaciones</Typography>

            <TextField                  
                required
                size="small"
                id="titulo"
                fullWidth
                label="Título de la implementación"
                name="titulo"
                value={titulo}
                onChange={handleChange}
                />
            <TextField                  
                required
                size="small"
                fullWidth
                id="empresa"
                label="Nombre de la empresa"
                name="empresa"
                value={empresa}
                onChange={handleChange}/>


            <TextField                  
                required
                size="small"
                fullWidth
                id="descripcion"
                multiline
                label="Descripción de la implementación"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <InputLabel id="categoria-label">Categoría de la implementación</InputLabel>
            <Select
                required
                size="small"
                fullWidth
                labelId="categoria-label"
                id="categoria"
                name='categoria'
                value={categoria}
                onChange={handleChange}
            >
                <MenuItem value="">Seleccionar categoría</MenuItem>
                <MenuItem value="tecnología">Tecnología</MenuItem>
                <MenuItem value="viajes">Viajes</MenuItem>
                <MenuItem value="comida">Comida</MenuItem>
                <MenuItem value="fruver">Frutas y verduras</MenuItem>
                {/* Agrega más categorías según tus necesidades */}
            </Select>

            <TextField                  
                required
                size="small"
                fullWidth
                id="dirweb"
                label="Link de la empresa"
                name="dirweb"
                value={urlarticulo}
                onChange={handleChange}/>

            <InputLabel id="fecha-label">Seleccione la fecha de la publicación</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="fecha"
                name="fecha"
                type='date'
                fecha={fecha} 
                onChange={handleChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />

            <InputLabel id="img-label">Seleccione una imagen</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="imagen"
                name="imagen"
                type='file'
                onChange={handleChange}
                inputProps={{ accept: 'image/*' }}/>

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mt: 3, mb: 2 }}
            >{programaSeleccionado ? 'Editar implementacion' : 'Agregar implementacion'}</Button>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>

    );
}

export default FormularioProgram;